import { AnimationClip, Object3D } from 'three';

import { sanitizeBindingNodeName } from '../threejs/patchSanitizeNodeName';

function collectSceneBindingNodeNames(root: Object3D): Set<string> {
  const names = new Set<string>();
  root.traverse((object) => {
    if (!object.name) {
      return;
    }
    names.add(object.name);
    names.add(sanitizeBindingNodeName(object.name));
  });
  return names;
}

function getTrackBindingNodeName(trackName: string): string | null {
  const morphMatch = trackName.match(/^([^.]+)\.morphTargetInfluences\[/);
  if (morphMatch?.[1]) {
    return morphMatch[1];
  }

  const lastDot = trackName.lastIndexOf('.');
  if (lastDot <= 0) {
    return null;
  }

  return trackName.slice(0, lastDot);
}

function isTrackBindableToRoot(
  trackName: string,
  bindableNames: Set<string>,
): boolean {
  const nodeName = getTrackBindingNodeName(trackName);
  if (!nodeName) {
    return true;
  }

  return (
    bindableNames.has(nodeName) ||
    bindableNames.has(sanitizeBindingNodeName(nodeName))
  );
}

export function filterAnimationClipTracksToRoot(
  clip: AnimationClip,
  root: Object3D,
): AnimationClip {
  const bindableNames = collectSceneBindingNodeNames(root);
  const filteredTracks = clip.tracks.filter((track) =>
    isTrackBindableToRoot(track.name, bindableNames),
  );

  if (filteredTracks.length === clip.tracks.length) {
    return clip;
  }

  const filteredClip = clip.clone();
  filteredClip.tracks = filteredTracks;
  return filteredClip;
}
